module.exports = __webpack_public_path__ + "static/media/workflux-forgotPassword.0decf18f.svg";